import React from 'react';
import Login from '../components/pages/login';
// Assuming Login is still in components/pages/login temporarily or we move it.
// For now, we import existing Login.

const Home = () => {
    return <Login />;
};

export default Home;
